import { camelCaseKeys } from 'launchdarkly-react-client-sdk';

export const convertToLDFeatureName = (inputString: string) => {
  return Object.keys(camelCaseKeys({ [inputString]: null }))[0];
};
